import type {
    guideTranscript_aiGuideThread_interactions as Interaction,
    guideTranscript_aiGuideThread as Thread,
} from "../guide-transcripts/__graphql-types__/guideTranscript.ts";

export const MOCK_THREAD: Thread = {
    __typename: "AIGuideThread",
    id: "threadId123",
    summary: "Summary",
    lastUpdatedAt: "2020-01-01T00:00:00Z",
    flagged: false,
    kaid: "kaid123",
    interactions: [],
    title: "Title",
    insights: {
        __typename: "AIGuideInsights",
        interests: "Interests",
        languages: "Languages",
        offTopic: "Off topic",
        safety: "Safety",
        summary: "Insights summary",
        title: "Title",
        topics: "Topics",
        math: '{ "mathDetected": "true" }',
    },
    coeditingDocument: null,
    blooketQuestionSet: null,
};

export const MOCK_INTERACTIONS: Array<Interaction> = [
    {
        __typename: "AIGuideInteraction",
        id: "1",
        createdAt: "2020-01-01T00:00:00Z",
        question: "What is the meaning of life?",
        answer: "42",
        url: "https://www.khanacademy.org/math/algebra2",
        flagged: false,
        flaggedCategories: [],
        responseWasStoppedByUser: false,
        traceID: "traceID123",
        userInputImage: false,
        imageMetadata: null,
        isClassroom: true,
        pageTitle: "Page Title",
        pageType: "",
        diagrams: [],
    },
    {
        __typename: "AIGuideInteraction",
        id: "2",
        createdAt: "2020-01-01T12:00:00Z",
        question: "Why was 7 afraid of 9?",
        answer: "Because 7 8 9",
        url: "https://www.khanacademy.org/math/algebra2",
        flagged: false,
        flaggedCategories: [],
        responseWasStoppedByUser: false,
        traceID: "traceID123",
        userInputImage: false,
        imageMetadata: null,
        isClassroom: true,
        pageTitle: "Page Title",
        pageType: "",
        diagrams: [],
    },
];

export const MOCK_FLAGGED_INTERACTIONS: Array<Interaction> = [
    MOCK_INTERACTIONS[0],
    {
        ...MOCK_INTERACTIONS[1],
        flagged: true,
        flaggedCategories: ["hate"],
    },
];

export const MOCK_WRITING_COACH_INTERACTION: Array<Interaction> = [
    {
        ...MOCK_INTERACTIONS[0],
        url: "https://www.khanacademy.org/writing-coach/essay/abc123/revising",
    },
];

export const MOCK_OLD_WRITING_COACH_INTERACTION: Array<Interaction> = [
    {
        ...MOCK_INTERACTIONS[0],
        url: "https://www.khanacademy.org/khanmigo/writing-coach/123/outlining",
    },
];

export const MOCK_CLASSROOM_INTERACTIONS: Array<Interaction> = [
    {
        ...MOCK_INTERACTIONS[0],
        url: "https://classroom.khanacademy.org/math/algebra2",
    },
    {
        ...MOCK_INTERACTIONS[1],
        url: "https://classroom.khanacademy.org/math/algebra2",
    },
];

export const MOCK_CLASSROOM_FLAGGED_INTERACTIONS: Array<Interaction> = [
    {
        ...MOCK_FLAGGED_INTERACTIONS[0],
        url: "https://classroom.khanacademy.org/math/algebra2",
    },
    {
        ...MOCK_FLAGGED_INTERACTIONS[1],
        url: "https://classroom.khanacademy.org/math/algebra2",
    },
];
